/**
 * @file EMETLUnitTreeColumn.js
 * © EMETL Working Group
 * 
 * This component represents a tree to set rank
 *
 * @author  Andrew Berger
 */

import React from "react"

import { 
    ListGroup, 
} from "react-bootstrap"

import EMETLUnitTreeCell from "../EMETLUnitTreeCell"

const EMETLUnitTreeColumn = (props) => {
    const { 
        data, 
        onSelect, 
        onContextOpen,
        selectedIndex, 
        style,
    } = props

    const handleCellSelection = (idx) => {
        onSelect(idx)
    }

    return (
        <ListGroup variant="flush" className="col-5 rounded" style={{ ...style, position: "relative" }}>
            {data && !!data.length && data.map(
                (cellData, idx) => {
                    return (                      
                        <EMETLUnitTreeCell
                            selected={idx === selectedIndex}
                            key={cellData.unitID}
                            name={cellData.name}
                            onSelect={() => handleCellSelection(idx)}
                            onContextOpen={onContextOpen}
                            unitID={cellData.unitID}
                        />
                    )
                }
            )}
        </ListGroup>
    )
}

export default EMETLUnitTreeColumn